
import { SanityCaseProcess } from '../models/sanity-case-process';
import { getSanityDataByParams } from './getSanityDataByParams';

export const getSanityCaseProcesseByParams = async (key: string, value: string): Promise<SanityCaseProcess[] | null> => {
  return await getSanityDataByParams<SanityCaseProcess>(key, value);
};